export const FORMAT_DATES = {
  standard: "DD/MM/YYYY",
  backend: "YYYY-MM-DD",
};
